import { Container } from "react-bootstrap";
// New package button
import { Button } from '@veeyaainnovatives/button';
import dots from "../../assets/images/dots.png";
import dotsLarge from "../../assets/images/dots-large.png";
import { useNavigate } from 'react-router-dom';
import contactData from '../../assets/static_datas/contact.json';

const Enrollment = ({ title, description, btns = [] }) => {

  const navigate = useNavigate();

  return (
    <Container>
      <div className="enrollment-design text-center position-relative">
        <img src={dotsLarge} alt="dots" className="dots-top" />
        <img src={dots} alt="dots" className="dots-bottom" />

        <h2 className="enrollment-title">{title}</h2>
        <p className="enrollment-desc">{description}</p>

        {/* Download Button */}
        {btns.includes('download') && (
          <Button 
            className="home-button"
            onClick={() => navigate('/vaastu-house-plans')}
          >
            Download Instantly
          </Button>
        )}

        {/* WhatsApp Button */}
        {btns.includes('whatsapp') && (
          <Button
            className="btn-bookaseat me-lg-4 mb-xl-0 mb-3"
            onClick={() => {
              // Get phone number from contact data and format for WhatsApp (remove +, spaces, dashes)
              const phoneNumber = contactData.phone.replace(/\s/g, '').replace(/-/g, '').replace(/\+/g, '');
              window.open(`https://wa.me/${phoneNumber}`, "_blank");
            }}
          >
            Whats App
          </Button>
        )}

        {/* Estimation Button */}
        {btns.includes('estimation') && (
          <Button
            className="btn-bookaseat-outline"
            variant="outline"
            borderWidth="3px"
            onClick={() => navigate('/contact-us')}
          >
            Get Estimate
          </Button>
        )}
      </div>
    </Container>
  );
};

export default Enrollment;
